
import LazyHydrate from 'vue-lazy-hydration';
import type Sale from '~/type/Sale';
interface Props {
  list: Sale[];
  type: 'list' | 'grid' | 'card';
}
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  type: {
    key: "type",
    required: false,
    type: String,
    default: 'card'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {};
};
__sfc_main.components = Object.assign({
  LazyHydrate
}, __sfc_main.components);
export default __sfc_main;
